export default {
    values: {
        critical: 'crítico',
        Critical: 'Crítico',
        CRITITAL: 'CRÍTICO',
        'non-critical': 'não critico',
        'Non-Critical': 'Não Crítico',
        'NON-CRITICAL': 'NÃO CRíTICO',
        'activities or systems': 'atividades ou sistemas',
        'Activities or Systems': 'Atividades ou Sistemas',
        'ACTIVITIES OR SYSTEMS': 'ATIVIDADES OU SISTEMAS',
        'barrier type': 'tipo de barreira',
        'Barrier Type': 'Tipo de Barreira',
        'BARRIER TYPE': 'TIPO DE BARREIRA',
        criticality: 'criticidade',
        Criticality: 'Criticidade',
        CRITICALITY: 'CRITICIDADE',
        process: 'organizacional',
        Process: 'Organizacional',
        PROCESS: 'ORGANIZACIONAL',
        'initial frequency': 'frequência inicial',
        'Initial Frequency': 'Frequência Inicial',
        'INITIAL FREQUENCY': 'FREQUÊNCIA INICIAL',
        'current frequency': 'Frequência atual',
        'Current Frequency': 'Frequência Atual',
        'CURRENT FREQUENCY': 'FREQUÊNCIA ATUAL',
        human: 'humana',
        Human: 'Humana',
        HUMAN: 'HUMANA',
        physical: 'física',
        Physical: 'Física',
        PHYSICAL: 'FÍSICA',
        responsible: 'responsável',
        Responsible: 'Responsável',
        RESPONSIBLE: 'RESPONSÁVEL',
        frequency: 'frquência',
        Frequency: 'Frequência',
        FREQUENCY: 'FREQUÊNCIA',
        consequences: 'consequências',
        Consequences: 'Consequências',
        CONSEQUENCIES: 'CONSEQUÊNCIAS',
        threats: 'ameaças',
        Threats: 'Ameaças',
        THREATS: 'AMEAÇAS',
        Crítical: 'Crítico',
        "I don'nt criticize": 'Não Crítico',
        manager: 'gerente',
        Manager: 'Gerente',
        MANAGER: 'GERENTE',
        barriers: 'barreiras',
        Barriers: 'Barreiras',
        BARRIERS: 'BARREIRAS',
        active: 'ativas',
        Active: 'Ativas',
        ACTIVE: 'ATIVAS',
        degraded: 'degradadas',
        Degraded: 'Degradadas',
        DEGRADED: 'DEGRADADAS',
        emergency: 'emergência',
        EMERGENCY: 'EMERGÊNCIA',
        Emergency: 'Emergência',
        maritime: 'marítimo',
        Maritime: 'Marítimo',
        MARITIME: 'MARÍTIMO',
        operation: 'operação',
        Operation: 'Operação',
        OPERATION: 'OPERAÇÃO',
        drilling: 'perfuração',
        Drilling: 'Perfuração',
        DRILLING: 'PERFURAÇÃO',
        'active barriers': 'barreiras ativas',
        'Active barriers': 'Barreiras ativas',
        'ACTIVE BARRIER': 'BARREIRA ATIVA',
        'ACTIVE BARRIERS': 'BARREIRAS ATIVAS',
        'degraded barriers': 'barreiras degradadas',
        'Degraded barriers': 'Barreiras degradadas',
        'DEGRADED BARRIERS': 'BARREIRAS DEGRADADAS',
        'DEGRADED BARRIER': 'BARREIRA DEGRADADA',
        'bowties with': 'bowties com',
        'Bowties with': 'Bowties com',
        'bowties with degraded barriers': 'bowties com barreiras degradadas',
        'Bowties with degraded barriers': 'Bowties com barreiras degradadas',
        mitigation: 'mitigação',
        Mitigation: 'Mitigação',
        MITIGATION: 'MITIGAÇÃO',
        prevention: 'prevenção',
        Prevention: 'Prevenção',
        PREVENTION: 'PREVENÇÃO',
        intolerable: 'intolerável',
        Intolerable: 'Intolerável',
        INTOLERABLE: 'INTOLERÁVEL',
        'widely acceptable': 'amplamente aceitável',
        'Widely Acceptable': 'Amplamente Aceitável',
        'WIDELY ACCEPTABLE': 'AMPLAMENTE ACEITÁVEL',
        tolerable: 'tolerável',
        Tolerable: 'Tolerável',
        TOLERABLE: 'TOLERÁVEL'
    }
}
